import { createContext } from "react";
import CryptoJS from "crypto-js"
import { UserAPI } from "../Api/UserAPI";
import axios from "axios";
export const UserContext=createContext()

export function sha256(message){
    return CryptoJS.SHA256(message).toString(CryptoJS.enc.Hex);
}

export function getUserFromToken(token,setUser,navigate,navigateBadToken="/",navigateGoodToken){
    if(token)
        axios.defaults.headers.common['user_authorization'] = `Bearer ${token}`;
        UserAPI.verifyLogin().then((response)=>{
            if(response.data){
                setUser(response.data.user)
                const remMe=localStorage.getItem("rememberMe")==="true"
                
                if (remMe){
                    localStorage.setItem('token',response.data.token)
                }
                else{
                    sessionStorage.setItem('token',response.data.token)
                }
                if(navigateGoodToken)
                        navigate(navigateGoodToken)
            }
        }).catch((err)=>{
            console.log(err)
            setUser(null)
            navigate(navigateBadToken)
        });    
}